export interface INavItem {
  id?: string;
  label: string;
  icon?: string;
  route?: string;
  permissions?: string[]; // example ['USER_LIST'] or ['USER_LIST', 'USER_CREATE']
  section?: 'Main' | 'Applications' | 'Management' | 'System' | string;
}


export const navigationMenu: INavItem[] = [
  // Main
  // {
  //   label: 'Dashboard',
  //   icon: 'dashboard',
  //   route: '/backoffice/dashboard',
  //   section: 'Main',
  //   permissions: []
  // },

  // Applications
  {
    label: 'Reserved Names',
    icon: 'bookmark',
    route: '/backoffice/reserved-names',
    section: 'Applications',
    permissions: ['APPLICATION_READ', 'APPLICATION_LIST','CLIENT_READ', 'CLIENT_LIST']
  },
  {
    label: 'Businesses',
    icon: 'business',
    route: '/backoffice/business/list',
    section: 'Applications',
    permissions: ['COMPANY_READ', 'COMPANY_LIST', 'APPLICATION_READ', 'APPLICATION_LIST']
  },
  // {
  //   label: 'Amendments',
  //   icon: 'edit_document',
  //   route: '/backoffice/amendments',
  //   section: 'Applications',
  //   permissions: ['APPLICATION_READ', 'APPLICATION_LIST', 'COMPANY_READ']
  // },
  {
    label: 'Expressions of Interest',
    icon: 'interests',
    route: '/backoffice/expressions-of-interest',
    section: 'Applications',
    permissions: ['EXPRESSION_OF_INTEREST_READ','APPLICATION_READ', 'APPLICATION_LIST']
  },
  {
    label: 'Licences',
    icon: 'badge',
    route: '/licensing',
    section: 'Applications',
    permissions: ['APPLICATION_READ', 'APPLICATION_LIST']
  },
  // { 
  //   label: 'Bank Accounts', 
  //   icon: 'account_balance', 
  //   route: '/backoffice/bank/accounts', 
  //   section: 'Applications',
  //   permissions: ['APPLICATION_READ', 'APPLICATION_LIST']
  // },


  // Management
  {
    label: 'Clients',
    icon: 'person',
    route: '/backoffice/clients',
    section: 'Management',
    permissions: ['CLIENT_READ', 'CLIENT_LIST','ADMIN_LIST']
  },
  {
    label: 'Users',
    icon: 'people',
    route: '/users',
    section: 'Management',
    permissions: ['USER_READ', 'USER_LIST']
  },
  // { label: 'Reports', icon: 'assessment', route: '/backoffice/reports', section: 'Management' },

  // System
  {
    label: 'Settings',
    icon: 'settings',
    route: '/settings',
    section: 'System',
    permissions: ['SETTING_READ', 'SETTING_LIST']
  },
  // { 
  //   label: 'Help & Support', 
  //   icon: 'help', 
  //   route: '/backoffice/help', 
  //   section: 'System',
  //   permissions: []
  // },
];
